import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import apiInstance from '../../utils/axios'

function CreatePassword() {
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [isLoading, setIsLoading] = useState(false) 

    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const otp = searchParams.get("otp")
    const uidb64 = searchParams.get("uidb64")

    const handlePasswordSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        
        if (password !== confirmPassword) {
            alert("Las contraseñas no coinciden")
            setIsLoading(false)
        } else {
            const formdata = new FormData()

            setIsLoading(true)

            formdata.append("password", password)
            formdata.append("uidb64", uidb64)
            formdata.append("otp", otp)

            try {
                await apiInstance.post(`user/password-change/`, formdata).then((res)=> {
                    alert("Contraseña cambiada")
                    navigate('/login')
                    setIsLoading(false)
                })
            } catch (error) {
                alert("Ocurrió un error")
                setIsLoading(false)
            }
        }
    }

    return (
        <section>
        <main className="" style={{ marginBottom: 100, marginTop: 50 }}>
            <div className="container">
                <section className="">
                    <div className="row d-flex justify-content-center">
                        <div className="col-xl-5 col-md-8">
                            <div className="card rounded-5">
                                <div className="card-body p-4">
                                    <h3 className="text-center">Crear Nueva Contraseña</h3>
                                    <br />
    
                                    <div className="tab-content">
                                        <div
                                            className="tab-pane fade show active"
                                            id="pills-login"
                                            role="tabpanel"
                                            aria-labelledby="tab-login"
                                        >
                                            <form onSubmit={handlePasswordSubmit}>
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="Full Name">
                                                        Ingresar Nueva Contraseña
                                                    </label>
                                                    <input
                                                        type="password"
                                                        required
                                                        name="password"
                                                        className="form-control"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                    />
                                                </div>
    
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="Full Name">
                                                        Confirmar Nueva Contraseña
                                                    </label>
                                                    <input
                                                        type="password"
                                                        required
                                                        name="confirmPassword"
                                                        className="form-control"
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                    />
                                                </div>
    
                                                {isLoading === true
                                            ?                                             
                                            <div className="text-center">
                                              <button disabled type="button" className='btn btn-primary w-100'>Procesando... <i className="fas fa-spinner fa-spin" /></button>
                                            </div>

                                            :
                                            <div className="text-center">
                                                <button type='submit' className='btn btn-primary w-100'>Restablecer Contraseña<i className='fas fa-check-circle'></i></button>
                                            </div>

                                            }
    
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    </section>
    )
}

export default CreatePassword
